import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function XeroCallback(): JSX.Element {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    useEffect(() => {
        const code = params.get('code');
        const redirectLocation = localStorage.getItem('xero-redirect');
        if (redirectLocation) {
            localStorage.removeItem('xero-redirect');
            navigate(`${redirectLocation}&code=${code}`);
        } else {
            const shortId = params.get('state');
            const code = params.get('code');
            const errorMsg = params.get('error');
            if (errorMsg || !code || !shortId) {
                navigate(`/${shortId}/entities/new?tab=xero&error=${true}`);
                return;
            }

            navigate(`/${shortId}/entities/new?tab=xero&code=${code}`);
        }
    }, [navigate, params]);

    return <div>Loading...</div>;
}
export default XeroCallback;
